// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-ASa","tabsBox":"styles_tabsBox__1Y_8E","createButton":"styles_createButton__2NjTI"};